import { httpClient } from '@/services/http/httpClient'

export async function deletePortfolioProject(id: string) {
  return await httpClient.delete(`/projects/portfolio-projects/${id}`)
}
